import 'core-js/stable'
import 'regenerator-runtime/runtime'
import  $  from 'jquery';
window.jQuery = $;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin, ScrollToPlugin );

import barba from '@barba/core';
//import barbaRouter from '@barba/router';


import Cookies from 'js-cookie';
import IonRangeSlider from 'ion-rangeslider';
import LocomotiveScroll from 'locomotive-scroll';

import {tns} from 'tiny-slider/src/tiny-slider';
import tippy from 'tippy.js';



import * as twgl from 'twgl.js/dist/4.x/twgl-full.module.js';

require('@fancyapps/fancybox');

const houses = {
    $floors : null,
    $imgs : null,
    $aparts: null,

    $floor1: null,
    $floor2: null,
    $floor3: null,
    $floor4: null,
    $floor5: null,
    $floor6: null,

    $aparts1: null,
    $aparts2: null,
    $aparts3: null,
    $aparts4: null,
    $aparts5: null,

    $controls: null,
    $tooltip: null,
    $tooltip2: null,

    setAparts: function(container = document){
        houses.$tooltip2 = $(container).find('.tooltip-apart');
        if(houses.$tooltip2.length === 0){
            return false;
        }
        $.each(data_aparts, function(){
            let apart = this;

            let $item = $(container).find('#_'+apart.number.replace(/\./g,'\\.'));
            $item.attr('href', $item.attr('href')+'/'+$item.data('name'));
            if(this.status === 'Laisvas'){
                $item.addClass('free').addClass('js-barba');
            }
            if(this.status === 'Rezervuotas'){
                $item.addClass('reserved').addClass('js-barba');
            }
            if(this.status === 'Parduotas'){
                $item.addClass('sold');
            }
            let price = houses.$tooltip2.find('.tooltip-apart--price');


            $item.mouseenter(function(){
                houses.$tooltip2
                    .removeClass('sold')
                    .removeClass('free')
                    .removeClass('reserved');

                

                if(apart.status === 'Laisvas'){
                    houses.$tooltip2.addClass('free');
                    if(typeof apart.price !== 'undefined'){
                        price.show();
                    }
                }
                if(apart.status === 'Rezervuotas'){
                    houses.$tooltip2.addClass('reserved');
                    price.hide();
                }
                if(apart.status === 'Parduotas'){
                    houses.$tooltip2.addClass('sold');
                    price.hide();
                }

                if(typeof apart.price === 'undefined' || apart.price === '0'){
                    price.hide();
                }

                houses.$tooltip2.find('.tooltip-apart--topLeft').html(apart.number);
                houses.$tooltip2.find('.tooltip-apart--status').html(statuses[apart.type][apart.status]);

                houses.$tooltip2.find('.tooltip-apart--area span').html(apart.area);

                if(apart.area == 0){
                    houses.$tooltip2.find('.tooltip-apart--area').hide();
                }else{
                    houses.$tooltip2.find('.tooltip-apart--area').show();
                }

                if(apart.type == 1){
                    houses.$tooltip2.find('.tooltip-apart--types').show();
                }else{
                    houses.$tooltip2.find('.tooltip-apart--types').hide();
                }

                houses.$tooltip2.find('.tooltip-apart--rooms span').html(apart.rooms)
                if(apart.rooms == 0){
                    houses.$tooltip2.find('.tooltip-apart--rooms ').hide()
                }else{
                    houses.$tooltip2.find('.tooltip-apart--rooms').show();
                }
                houses.$tooltip2.find('.tooltip-apart--price').html(apart.price + ' €');


            }).mousemove(function(e){

                let _width = houses.$tooltip2.outerWidth();
                let _height = houses.$tooltip2.outerHeight();
                let offset = houses.containerSvg.offset();
                let fix = _width/2;

                let y = e.pageY - offset.top - _height - 10;
                let x = e.pageX - offset.left - _width/2;

                console.log('aa: ' + (offset.top - _height - 10)*-1);
                console.log('pageY :' + e.pageY);

                console.log(e.pageY <= ((offset.top - _height - 10)*-1));
                if(e.pageY <= ((offset.top - _height - 10)*-1)){
                    houses.$tooltip2.addClass('overflow-fix');
                    y = e.pageY + offset.top  + 25;
                }else{
                    houses.$tooltip2.removeClass('overflow-fix');
                }

                if(houses.$tooltip2.width() /2 > e.pageX){
                    x = x + fix;
                }

                if(houses.containerSvg.width() < (e.pageX + fix)){
                    x = x - fix;
                }

                houses.$tooltip2.css({
                    left : x,
                    top : y,
                    opacity: 1
                });

            }).mouseleave(function(e){
                houses.$tooltip2.css({
                    opacity: 0
                });
            })
        })
    },
    init: function(container = document){
        let obj = this;

        obj.$circles = $(container).find('.plus');
        obj.$floors = $(container).find('.floor-select');
        obj.$floor0 = $(container).find('.floor-0');
        obj.$floor1 = $(container).find('.floor-1');
        obj.$floor2 = $(container).find('.floor-2');
        obj.$floor3 = $(container).find('.floor-3');
        obj.$floor4 = $(container).find('.floor-4');
        obj.$floor5 = $(container).find('.floor-5');
        obj.$floor6 = $(container).find('.floor-6');

        obj.$houses = $(container).find('.tooltip-house');
        obj.$aparts = $(container).find('.aparts');
        obj.$imgs = $(container).find('.floor-img');

        obj.$controls = $(container).find('.floor-nav-select');
        obj.$tooltip = $(container).find('.tooltip-floor');
        obj.$tooltipSpec = $(container).find('.tooltip-spec');
        obj.containerSvg = $(container).find('.sct-houses--svg');

        obj.$spec = $(container).find('.spec-zone');

        obj.setAparts(container);

        obj.$floors.mouseenter(function(){
            let $this = $(this);
         //   console.log("floor");
            let $floor = $this.data('floor');
            let $house = $this.data('house');

            obj.$floors.removeClass('hover');
           // $(container).find('[data-floor="'+$floor+'"]').addClass('hover');
            $.each($(container).find('[data-floor="'+$floor+'"]'),function(){
                let $this = $(this);
                if(!$this.hasClass('.floor-nav-select')){
                    $this.addClass('hover')
                }
            })
            obj.$tooltip.find('.tooltip-floor--nr').html($house);
            obj.$tooltip.find('.tooltip-floor--floor span').html($floor);
            obj.$tooltip.find('.tooltip-floor--free span').html(data_houses[$house][$floor]);






        }).mousemove(function(e){
            let _width = obj.$tooltip.outerWidth();
            let _height = obj.$tooltip.outerHeight();
            let offset = obj.containerSvg.offset();
            let fix = _width/2;

            let y = e.pageY - offset.top - _height - 10;
            let x = e.pageX - offset.left

        //    console.log('y: '+ y);
       //     console.log('pageY: '+e.pageY);

            if(obj.$tooltip.width() /2 < e.pageX){
                x = x - fix;
            }

            if(obj.containerSvg.width() < (e.pageX + fix)){
                x = x - fix;
            }

            obj.$tooltip.css({
                left : x,
                top : y,
                opacity: 1
            });

        }).mouseleave(function(){
            obj.$floors.removeClass('hover');
            obj.$tooltip.css({'opacity':0});
        }).click(function(){
            let $this = $(this);
            let floor = $this.data('floor');
            obj.$controls.removeClass('active');
            obj.$houses.css({opacity:0});
            $.each(obj.$controls, function(){
                if($(this).data('floor') === floor){
                    $(this).addClass('active');
                }
            })
            obj.toggleFloor(floor);

            setParams('house_floor', floor);
            history.pushState(null, '',window.location.href);

        });

        obj.$spec.mouseenter(function(e){
            let $this = $(this);
            let type = $this.data('type');

        //    obj.$tooltipSpec.html(data_spec[type]);
         //   obj.$tooltipSpec.css({opacity : 1});

            let $circle = $(document).find('.'+type)

            if($circle.length > 0) {
                $circle.addClass('hover');
            }

            console.log($circle);

        }).mousemove(function(e){
         /*   let _width = obj.$tooltipSpec.outerWidth();
            let _height = obj.$tooltipSpec.outerHeight();
            let offset = obj.containerSvg.offset();
            let fix = _width/2;

            let y = e.pageY - offset.top - _height - 10;
            let x = e.pageX - offset.left

            if(obj.$tooltipSpec.width() /2 < e.pageX){
                x = x - fix;
            }

            if(obj.containerSvg.width() < (e.pageX + fix)){
                x = x - fix;
            }

            obj.$tooltipSpec.css({
                left : x,
                top : y,
                opacity: 1
            });*/

        }).mouseleave(function(e){
        //    obj.$tooltipSpec.css({opacity : 0})
            let $this = $(this);
            let type = $this.data('type');
            let $circle = $(document).find('.'+type);
            if($circle.length > 0) {
                $circle.removeClass('hover');
            }
        })


        obj.$controls.on('click', function(e){
            e.preventDefault();
            let $this = $(this);
            obj.$houses.css({opacity:0});
            obj.$controls.removeClass('active')
            $this.addClass('active');
            let floor = $this.data('floor');
            obj.toggleFloor(floor);
            setParams('house_floor', floor);
            history.pushState(null, '',window.location.href);

        })


    },
    toggleFloor(floor){
   //     console.log('wtf');
        houses.$floors.removeClass('hidden');
        houses.$imgs.removeClass('active');
        houses.$aparts.removeClass('active')
        $.each(houses.$imgs,function(){
            let $this = $(this);
            if($this.hasClass('floor-'+floor)){
                $this.addClass('active');
            }
        });

        $.each(houses.$aparts, function(){
            let $this = $(this);
            if($this.hasClass('aparts-'+floor)){
                $this.addClass('active');
            }
        })

        let $btn = $(document).find('.view360-btn');

        $btn.removeClass('show')
        switch(floor){
            case(5):
                houses.$floor6.addClass('hidden');
                houses.$floor5.addClass('hidden');
                break;
            case(4):
                houses.$floor6.addClass('hidden');
                houses.$floor5.addClass('hidden');
                houses.$floor4.addClass('hidden');
                break;
            case(3):
                houses.$floor6.addClass('hidden');
                houses.$floor5.addClass('hidden');
                houses.$floor4.addClass('hidden');
                houses.$floor3.addClass('hidden');
                break;
            case(2):
                houses.$floor6.addClass('hidden');
                houses.$floor5.addClass('hidden');
                houses.$floor4.addClass('hidden');
                houses.$floor3.addClass('hidden');
                houses.$floor2.addClass('hidden');
                break;
            case(1):
                houses.$floor6.addClass('hidden');
                houses.$floor5.addClass('hidden');
                houses.$floor4.addClass('hidden');
                houses.$floor3.addClass('hidden');
                houses.$floor2.addClass('hidden');
                houses.$floor1.addClass('hidden');
                break;
            case(0):
                $btn.addClass('show')
                houses.$floor6.addClass('hidden');
                houses.$floor5.addClass('hidden');
                houses.$floor4.addClass('hidden');
                houses.$floor3.addClass('hidden');
                houses.$floor2.addClass('hidden');
                houses.$floor1.addClass('hidden');
                break;
        }

        if(floor === 0){
            houses.$circles.addClass('active');
        }else{
            houses.$circles.removeClass('active');
        }

    }

}
const apartment = {
    controlsClass: '.apartment-imgs--controls',
    init: function(container = document){
        let obj = this;
        let $imgs = $(container).find('.apartment-img');
        let $controls = $(container).find(obj.controlsClass);

        if($controls.length > 0){

            $controls.on('click', function( ){
                $(this).toggleClass('reverse');
                $imgs.toggleClass('active');
            })
        }

        obj.$calc = $(container).find('.toggle-calc');
        obj.$table = $(container).find('.calc-table0');

        obj.$bank = $(container).find('.toggle-bank');
        obj.$table1 = $(container).find('.calc-table1');

        obj.$deco = $(container).find('.toggle-furn');
        obj.furn = $(container).find('.furn-table');

        if(obj.$calc.length > 0 &&  obj.$table.length > 0){
            obj.$calc.on('click', function(){
                obj.$table.toggleClass('active');
            })
        }

        if(obj.$bank.length > 0 &&  obj.$table1.length > 0){
            obj.$bank.on('click', function(){
                obj.$table1.toggleClass('active');
            })
        }

        if(obj.$deco.length > 0 &&   obj.furn.length > 0){
            obj.$deco.on('click', function(){
                obj.furn.toggleClass('active');
            })
        }


        $(document).on('click', function(e){
            if($(e.target).parents('.extra-options--calc').length === 0){
                obj.$table.removeClass('active');
            }

            if($(e.target).parents('.extra-options--deco').length === 0){
                obj.furn.removeClass('active');
            }

            if($(e.target).parents('.extra-options--btn').length === 0){
                obj.$table1.removeClass('active');
            }

        })

        obj.$load = $(container).find('.loan-calc');

        let $_perc = $(container).find('.calc-slider--percent');

        let price = $_perc.data('price');
        let init = 0;
        let val = 15;

        let rez = parseInt((price / 100) * parseInt(val) ).toLocaleString();
        let end = '(' + rez.replace(',', ' ') + ' €)';


        let $_slide =  $('.calc-slider--percent').ionRangeSlider({
            postfix: '<span>'+end+'</span>',
            prettify: function (a) {
                a = a + '% ';
                return a;
            },
            onStart: function (a) {

            },
            onUpdate: function (a){


            },
            onChange: function (a) {
                let $cont = $_slide.prev().find('.irs-single span');
                let val = $_slide.val();
                let rez = parseInt((price / 100) * parseInt(val) ).toLocaleString();

                $cont.html('(' + rez.replace(',', ' ') + ' €)');
            },
            onFinish:function(a){
                obj.$load.submit();
            }
        });

        let $_time = $('.calc-slider--time').ionRangeSlider({
            onStart: function (a) {

            },
            onUpdate: function (a){

            },
            onChange: function (a) {

            },
            onFinish:function(a){
                obj.$load.submit();
            }
        });

        obj.$load.submit(function (e) {
            e.preventDefault();
            let $this = $(this);
            $.ajax({
                url: $this.attr('action'),
                data: $this.serialize(),
                type: 'POST'
            }).done(function (data) {
                $this.find('.calc-table--resultFinal span').html(data);
            })
        });
        obj.$load.submit();

        let $floor = $(container).find('.extra-floors--svg');

        if($floor.length > 0) {
            let $aparts = $floor.find('a');
            $.each($aparts, function(){
                $(this).attr('href', $floor.data('url')+'/'+$(this).data('name'));

                if($(this).data('name') === $floor.data('number')){
                    $(this).addClass('current');
                }
            })

            $.each(data_aparts, function(){
                if(this.status === 'Laisvas'){
                    $floor.find('#_'+this.number.replace(/\./g,'\\.')).addClass('free')
                }
                if(this.status === 'Rezervuotas'){
                    $floor.find('#_'+this.number.replace(/\./g,'\\.')).addClass('reserved')
                }
                if(this.status === 'Parduotas'){

                    $floor.find('#_'+this.number.replace(/\./g,'\\.')).addClass('sold').attr('href','').removeClass('js-barba');
                }
            })
        }

        let $btns = $(container).find('.extra-floors--selectBtn');
        let $floors = $(container).find('.extra-floors--floor');
        $btns.on('click', function(){
            let $this = $(this);
            $btns.removeClass('active');
            $floors.removeClass('active');
            $this.addClass('active');
            let $_floor = $this.data('floor');
            $.each($floors, function(){
                if($(this).data('floorsvg') === $_floor){
                    $(this).addClass('active');
                }
            })

        })

        let $housesInfo = $(container).find('.extra-housesSelect');
        let $houses = $(container).find('.filter-svg');
        $.each($houses, function(){
            let $this = $(this);
            if($housesInfo.data($this.attr('id')) !== 0){
                $this.on('click', function(){
                    barba.go($housesInfo.data($this.attr('id')));
                })

            }else{
                if(!$this.hasClass('is-active')) {
                    $this.addClass('denied');
                }
            }
        })


        const galleryEl = container.querySelector('.apartment-gallery-sp');
        if(galleryEl != undefined) {
            galleryEl.addEventListener('click',(e) => {
                e.preventDefault();
                container.querySelector('.gallery a').click();
            })
        }

    }
}
const parking = {
    class: '',

    init: function(container = document){
        let obj = this;
        if(typeof data_storage === 'undefined'){
            return false;
        }

        obj.$tooltip = $(container).find('.tooltip');

        $.each(data_storage, function(){
            let data = this;
            let $zone = $(container).find('#_'+data.number);
            let $svg = $(container).find('.parking svg');
            if($zone.length > 0) {
                if (data.status === 'Laisvas') {
                    $zone.addClass('free');
                }
                if (data.status === 'Rezervuotas') {
                    $zone.addClass('reserved');
                }
                if (data.status === 'Parduotas') {
                    $zone.addClass('sold');
                }

                let $nr = obj.$tooltip.find('.tooltip-parking--nr');
                let $type = obj.$tooltip.find('.tooltip-parking--type');
                let $status = obj.$tooltip.find('.tooltip-parking--status')
                let $price = obj.$tooltip.find('.tooltip-parking--price');
                let $area = obj.$tooltip.find('.tooltip-parking--area');

                $zone.on('mouseenter', function(){

                    obj.$tooltip
                        .removeClass('sold')
                        .removeClass('free')
                        .removeClass('reserved');

                    $type
                        .removeClass('parking')
                        .removeClass('storage');

                    if(data.status === 'Laisvas'){
                        obj.$tooltip.addClass('free');
                        if(typeof data.price !== 'undefined'){
                            $price.show();
                        }
                    }
                    if(data.status === 'Rezervuotas'){
                        obj.$tooltip.addClass('reserved');
                        $price.hide();
                    }
                    if(data.status === 'Parduotas'){
                        obj.$tooltip.addClass('sold');
                        $price.hide();
                    }

                    if(typeof data.price === 'undefined' || data.price === '0'){
                        $price.hide();
                    }
                    if(typeof data.area !== 'undefined'){
                        if(data.area === '0'){
                            $area.html('');
                        }else {
                            $area.html(data.area + ' m<sup>2</sup>')
                        }
                    }


                    $nr.html(data.number);
                    $type.addClass(data.type);
                    $status.html(data.status);
                    $price.html(data.price+ ' €');

                }).on('mouseleave', function(){
                    obj.$tooltip.css({
                        opacity: 0
                    });
                }).on('mousemove', function(e){
                    let _width = obj.$tooltip.outerWidth();
                    let _height = obj.$tooltip.outerHeight();
                    let offset = $svg.offset();

                    let y = e.pageY - offset.top - _height - 10;
                    let x = e.pageX - offset.left - _width/2;

                    obj.$tooltip.css({
                        left : x,
                        top : y,
                        opacity: 1
                    });
                })


            }
        })
    }
}
const menu = {
    toggle : '.menuToggle',
    header : '.header',
    close: '.bt-close',
    scrolled : false,
    menu : '.menu',
    init: function(container = document,locoScroll){
        let obj = this;

        let $menu = $(container).find(obj.menu);
        let $close = $(container).find(obj.toggle);
        let $header = $(container).find(obj.header);

        $close.on('click', function(){
            $menu.toggleClass('active');
            $header.toggleClass('menu-open');

            if($header.hasClass('menu-open')){
                $header.removeClass('scrolled');
            }else if( menu.scrolled && !$header.hasClass('menu-open')){
                $header.addClass('scrolled');
            }
        })

    },
    changeHeader: function(container){
        let obj = menu;
        let $header = $(obj.header);
        let $menu = $(document).find(obj.menu);


        if(typeof $(container).data('header') !== 'undefined'){
            $header.removeClass('light').addClass('green');
        }else{
            $header.removeClass('green').addClass('light');
        }
        $menu.removeClass('active');
        $header.removeClass('menu-open');

    }

}
const scrollto = {
    class: '.scroll-to',
    init: function(container = document, locoScroll){
        let obj = this;
        //let $scroll = $(container).find(obj.class);

        $(document).on('click',obj.class,function(e){
            e.preventDefault();
            let $this = $(this);
            let $target = $(container).find($this.data('target'));
            if($target.length > 0){
                locoScroll.scrollTo($this.data('target'),{
                    offset: -75
                })

                $(menu.menu).removeClass('active');
                $(menu.header).removeClass('menu-open')
            }
        })

    }
}
const duk = {
    class : '.duk-item',
    init: function(container = document){
        let obj = this;
        let $items = $(container).find(obj.class);

        $.each($items, function(){
            let $this = $(this);
            let $title = $this.find('.duk-title');
            let $cont = $this.find('.duk-cont');
            $title.on('click', function(){
                $this.toggleClass('duk-item--active');
                $cont.slideToggle();
            })
        })

    }
}
const gallery = {
    class : '.gallery-container',
    init: function(container = document){
        let obj = this;

        if($(obj.class).length) {
            let slider = tns({
                container: obj.class,
                items: 2,
                slideBy: 1,
                autoplay: false,
                loop: false,
                prevButton: $(container).find('.gallery-control--left button')[0],
                nextButton: $(container).find('.gallery-control--right  button')[0],
                responsive: {
                    300: {
                        items: 1
                    },
                    800: {
                        items: 2
                    }
                },
                onInit: function (slider) {
                    let $items = $(slider.container).find('.tns-slide-active');
                    $($items[0]).addClass('tns-slide--left');
                    $($items[1]).addClass('tns-slide--right');
                }
            });

            let $ctrl = $(container).find('.gallery-control');
            $ctrl.on('click', function () {

                let info = slider.getInfo();
                $(info.container)
                    .find('.tns-item')
                    .removeClass('tns-slide--left')
                    .removeClass('tns-slide--right');

                let $items = $(info.container).find('.tns-slide-active');
                $($items[0]).addClass('tns-slide--left');
                $($items[1]).addClass('tns-slide--right');
            })

        }
    }
}

const map = {
    container : '#map',
    map : null,
    styleClass: 'gmap',
    instance: null,
    controls: '.bt-map',
    main: null,
    markers: [],
    infoWindows: [],
    toggle: '',
    cat : 0,
    options: {
        center: null,
        zoom: 16,
        panControl: false,
        zoomControl: true,
        
        mapTypeControl: false,
        overviewMapControl: false,
        scaleControl: false,
        streetViewControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
        styles:[
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e7de"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#d2d6c8"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#cbccce"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ],
    },
    init: function(container = document, locoScroll){
        let obj = this;

        if(typeof google === 'undefined'){
            return false;
        }
        map.options.zoomControlOptions = {
            position: google.maps.ControlPosition.LEFT_BOTTOM
        }
        let $map = $(container).find(obj.container);



        if($map.length === 0){
            return false;
        }
        if(typeof mapPoints === 'undefined'){
            console.log('No main data');
            return false;
        }

        if(typeof mapMain === 'undefined'){
            console.log('No main marker')
        }


        if(obj.instance === null){
            obj.options.zoom = parseInt(mapMain.zoom);
            mapMain.coords = mapMain.coords.split(',');
            mapMain.center = mapMain.center.split(',');
            obj.options.center =  new google.maps.LatLng(mapMain.center[0], mapMain.center[1]);
            obj.instance = obj.createNewInstance();
            obj.createMarkers();
        }

        let $btns = $(container).find(obj.controls);

        //   let bounds = new google.maps.LatLngBounds();

        if(obj.cat !== 0) {
            $(container).find(obj.controls+'[data-cat="'+obj.cat+'"]').addClass('active');
        }
        $btns.click(function(e){
            e.preventDefault();
            let $this = $(this);
            let cat = $this.data('cat');
            let bounds = new google.maps.LatLngBounds();
            bounds.extend( new google.maps.LatLng(mapMain.coords[0], mapMain.coords[1]));
            if($this.hasClass('active')){
                $this.removeClass('active');
                $.each(obj.markers, function(i, marker){
                    if(typeof marker !== 'undefined') {
                        marker.setMap(obj.instance.map);
                        bounds.extend(marker.position);
                    }
                });
                obj.cat = 0;
            }else {
                $btns.removeClass('active');
                $this.addClass('active');
                $.each(obj.markers, function (i, marker) {
                    if(typeof marker !== 'undefined'){

                        if (parseInt(marker.type) == cat) {
                            marker.setMap(obj.instance.map);
                            bounds.extend(marker.position);
                        } else {
                            marker.setMap(null);
                        }
                    }
                });
                obj.cat = cat;
            }
            obj.instance.map.fitBounds(bounds);
           // if($(window).width() < 870){
               /* gsap.to(window, {
                    scrollTo: ($(container).find('#map').offset().top )
                });*/

                locoScroll.scrollTo('#map',{
                    offset: -75
                })
           // }
        });

        $(container).find(obj.container).html(obj.instance['div']);

        obj.$toggle = $(container).find('.controls-toggle');
        obj.$toggle.click(function(){
            $(this).toggleClass('active');
            $(container).find('.map-controls').slideToggle();
        })

    },
    createNewInstance : function(){
        let obj = this;
        let div = $("<div></div>").addClass(this.styleClass);
        let map =   new google.maps.Map(div[0], obj.options);

        return {
            map: map,
            div: div
        }
    },
    createMarkers : function(){
        let obj = this;
        if(obj.instance.length === 0){
            console.log('No map instance ');
            return false;
        }
        //  let bounds = new google.maps.LatLngBounds();
        if(typeof mapPoints !== 'undefined'){

            $.each(mapPoints, function(i, marker){

                let icon;
                icon = {
                    url: 'assets/svg/'+marker.category+'_marker.svg',
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(22, 22),
                    scaledSize: new google.maps.Size(45, 45)
                };

                obj.markers[i] = new google.maps.Marker({
                    position: new google.maps.LatLng(marker.lat, marker.lng),
                    title: marker.title,
                    map: obj.instance.map,
                    icon: icon,
                    visible: true,
                    zIndex: 80,
                    main: false,
                    type: marker.category,
                    opened: false
                });

                //    bounds.extend(obj.markers[i].position);

                let className = '';
                if(marker.walk === '' && marker.car === ''){
                    className = 'gmap-info--timesSingle';
                }

                let walk = '';
                let car = '';
                if(marker.car !== ''){
                    walk = '<div class="gmap-info--car"><img src="assets/svg/masina.svg">'+marker.car+'</div>';

                }
                if(marker.walk !== ''){
                    car = '<div class="gmap-info--walk"><img src="assets/svg/batas.svg">'+marker.walk+'</div>' ;
                }

                let infoContent =
                    '<div class="gmap-info">' +
                    '<div class="gmap-info--inner">' +
                    '<div class="gmap-info--title">'+marker.title+'</div>' +
                    '<div class="flx gmap-info--times '+className+'">' +
                    walk +
                    car+
                    '</div>'+
                    '</div>' +
                    '</div>';

                let infowindow = new google.maps.InfoWindow({
                    content: infoContent
                });
                infowindow.setZIndex(9999);
                obj.infoWindows.push(infowindow);


                google.maps.event.addListener(obj.markers[i], 'click', function () {
                    $.each(obj.infoWindows, function(){
                        this.close();
                    });
                    console.log(obj.markers[i]);
                    if(obj.markers[i].opened == false){
                        infowindow.open(obj.instance.map, obj.markers[i]);
                        obj.markers[i].opened = true;
                    }else{
                        obj.markers[i].opened = false;
                    }
                });

                google.maps.event.addListener(obj.instance.map, 'click', function () {
                    infowindow.close(obj.instance.map, obj.markers[i]);
                });

            });

        }

        if(typeof mapMain  !== 'undefined'){
            let icon;

            icon = {
                url: 'assets/svg/Zemelapio_zymeklis.svg',
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(105, 101),
                scaledSize: new google.maps.Size(211, 101)
            };

            obj.main = new google.maps.Marker({
                position: new google.maps.LatLng(mapMain.coords[0], mapMain.coords[1]),
                title: mapMain.title,
                map: obj.instance.map,
                icon: icon,
                visible: true,
                zIndex: 9999,
                main: true,
                type: 0
            });

            let infoContent =
                '<div class="gmap-info gmap-info--main">' +
                '<div class="gmap-info--inner">' +
                '<div class="gmap-info--title">'+mapMain.title +'</div>' +
                '</div>'+
                '</div>';

            let infowindow = new google.maps.InfoWindow({
                content: infoContent
            });

            google.maps.event.addListener( obj.main, 'click', function () {
                infowindow.open(obj.instance.map, obj.main);
            });

            //    bounds.extend(obj.main.position);
        }
        //   obj.instance.map.fitBounds(bounds);
    },
    leave: function () {
        let obj = this;
        if(obj.$btns.length){
            obj.$btns.off();
            obj.$btns = null;
        }
    }



};
let form = {
    $inputs: null,
    $inputs2: null,
    init: function(container = document){
        let obj = form;

        if(obj.$inputs !== null){
            obj.$inputs.off();
            obj.$inputs = null;
        }
        if(obj.$inputs2 !== null){
            obj.$inputs2.off();
            obj.$inputs2 = null;
        }

        obj.$inputs = $(container).find('.form-input > input');

        obj.$inputs2 = $(document).find('.popupForm-input > input');

        function updateText(event) {
            let input = $(this);
            input.parent().removeClass('error');
            setTimeout(function () {
                let val = input.val();
                if (val !== "") {
                    input.parent().addClass("float");
                } else {
                    input.parent().removeClass("float");
                }
            }, 1)
        }

        if(obj.$inputs.length > 0) {

            obj.$inputs
                .keydown(updateText)
                .change(updateText)
                .focusin(function(){$(this).parent().addClass('float')})
                .focusout(updateText)
            obj.$inputs2
                .keydown(updateText)
                .change(updateText)
                .focusin(function(){$(this).parent().addClass('float')})
                .focusout(updateText)

            const checkbox = $(".form-checkbox").find('input');
            const checkbox2 = $('.popupForm-checkbox').find('input');
            checkbox.change(function (event) {
                var checkbox = event.target;
                if (checkbox.checked) {
                    $(this).parent().removeClass('error')
                }
            });

            checkbox2.change(function (event) {
                var checkbox = event.target;
                if (checkbox.checked) {
                    $(this).parent().removeClass('error')
                }
            });
        }



        $(document).find('form.form, .popupForm').submit(function(e){
            e.preventDefault();
            let $this = $(this);
            let $bt = $this.find('button');
            $bt.prop('disabled', true);

            let $error = $this.find('.form-errors');
            let $errors = $this.find('.error').removeClass('error');
            let $fields = $('.form-inputs');
            $this.find('.ref').val(window.location.href);

            $.post(
                $this.attr('action'),
                $this.serialize())
                .done(function( data ) {
                    if(data.status == 0){
                        $error.addClass('error');
                        $.each(data.errors, function(){
                            $('#field-'+this[1]).parent().addClass('error').find('.form-input--error').html(this[0]);
                        })
                        $bt.prop('disabled', false);
                    }else{
                        dataLayer.push({'event': 'FormSubmission'});
                        $fields.hide();
                      /*  gsap.to($fields,{
                            autoAlpha:0,
                            onComplete: function(){
                                $fields.css({
                                    pointerEvents: 'none'
                                })
                            }})*/
                        $(document).find('.new-hide').hide();
                        gsap.to( $this.find('.form-success'),{autoAlpha:1, onComplete: function(){
                                $this.addClass('hide');
                            }});

                    }
                });

            return false;
        });
    }
};
const GradBg = {
    v:{
        c:null,
        gl:null,
        pinf:null,
        binf:null,
        prog:null,
        pArr:{
            position: [-1, -1, 0, 1, -1, 0, -1, 1, 0, -1, 1, 0, 1, -1, 0, 1, 1, 0],
        },
        uniforms: {
            time: 0,
            resolution: [100,100],
            scroll: 0,
            mouseX: 0,
            mouseY: 0,
            clickX: 0,
            clickY: 0,
            cprog: 0,
            toplayer: 0.1
        },
        updated: false,
        mouse: {
            x:0.5,
            y:0.5,
            tx:0.5,
            ty:0.5
        },
        loco:null
    },

    init: function(loco){
        let $t = this;
        let $v = $t.v;

        $v.loco = loco;

        $v.c = $("#gradbg");
        if($v.c.length == 0){
            console.log("Background canvas not found");
            return false;
        }
        $v.gl = $v.c[0].getContext("webgl");
        $v.prog = twgl.createProgramFromSources($v.gl, [$t.vshader, $t.fshader]);
        $v.pinf = twgl.createProgramInfoFromProgram($v.gl, $v.prog);
        $v.binf = twgl.createBufferInfoFromArrays($v.gl, $v.pArr);
        //

        twgl.resizeCanvasToDisplaySize($v.gl.canvas);
        $v.uniforms.resolution[0] = $v.gl.canvas.width;
        $v.uniforms.resolution[1] = $v.gl.canvas.height;
        $v.updated = true;

        requestAnimationFrame($t.render);

        /* ScrollTrigger.create({
            trigger: ".content",
            start: "top bottom",
            end: "bottom top",
            onUpdate: self => {
                //console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
                $v.uniforms.scroll = self.progress;
                $v.updated = true;
            }
        }); */
        loco.on('scroll',function(s){
            //console.log(s.scroll.y / s.limit.y);
            let prg = s.scroll.y / s.limit.y;
            $v.uniforms.scroll = prg;
            $v.updated = true;
        });

        window.addEventListener("resize", function(){
            twgl.resizeCanvasToDisplaySize($v.gl.canvas);
            $v.uniforms.resolution[0] = $v.gl.canvas.width;
            $v.uniforms.resolution[1] = $v.gl.canvas.height;
            $v.updated = true;
        });

        window.addEventListener("mousemove", function(e){
            $v.mouse.tx = e.clientX / $v.gl.canvas.width - 0.5;
            $v.mouse.ty = e.clientY / window.innerHeight - 0.5;
            /* $v.uniforms.mouseX = e.clientX / $v.gl.canvas.width - 0.5;
            $v.uniforms.mouseY = e.clientY / window.innerHeight - 0.5;
            $v.updated = true; */
        });

        window.addEventListener("click", function(e){
            $v.uniforms.clickX = e.clientX / $v.gl.canvas.width;
            $v.uniforms.clickY = 1 - e.clientY / window.innerHeight;
            gsap.fromTo($v.uniforms, {cprog:0}, {cprog:1, duration:1, ease:"power2.out", onUpdate:function(){
                $v.updated = true;
            }});
            $v.updated = true;
        });
    },

    render: function(t){
        let $t = GradBg;
        let $v = $t.v;
        let m = $v.mouse;
        if(m.tx != m.x){
            $v.updated = true;
            if(Math.abs(m.tx - m.x) <= 0.0001){
                m.x = m.tx;
            }else{
                m.x += (m.tx - m.x) * 0.07;
            }
            $v.uniforms.mouseX = m.x;
        }
        if(m.ty != m.y){
            $v.updated = true;
            if(Math.abs(m.ty - m.y) <= 0.0001){
                m.y = m.ty;
            }else{
                m.y += (m.ty - m.y) * 0.07;
            }
            $v.uniforms.mouseY = m.y;
        }


        requestAnimationFrame($t.render);
        if(!$v.updated) return false;
        $v.updated = false;
        $v.gl.viewport(0, 0, $v.gl.canvas.width, $v.gl.canvas.height);

        $v.uniforms.time = t * 0.001;

        $v.gl.useProgram($v.pinf.program);
        twgl.setBuffersAndAttributes($v.gl, $v.pinf, $v.binf);
        twgl.setUniforms($v.pinf, $v.uniforms);
        twgl.drawBufferInfo($v.gl, $v.binf);

        //
    },


    vshader: `
        attribute vec4 position;

        void main() {
            gl_Position = position;
        }`,
    fshader: `
        precision mediump float;

        uniform vec2 resolution;
        uniform float time;
        uniform float scroll;
        uniform float mouseX;
        uniform float mouseY;
        uniform float clickX;
        uniform float clickY;
        uniform float cprog;
        uniform float toplayer;

        const highp float NOISE_GRANULARITY = 0.5 / 255.0;

        float rand(float n){return fract(sin(n) * 43758.5453123);}
        float rand(vec2 n) { 
            return fract(sin(dot(n, vec2(12.989898, 4.141414))) * 43758.5453);
        }

        float noise(float p){
            float fl = floor(p);
            float fc = fract(p);
            return mix(rand(fl), rand(fl + 1.0), fc);
        }
            
        float noise(vec2 n) {
            const vec2 d = vec2(0.0, 1.0);
            vec2 b = floor(n), f = smoothstep(vec2(0.0), vec2(1.0), fract(tan(n)));
            return mix(mix(rand(b), rand(b + d.yx), f.x), mix(rand(b + d.xy), rand(b + d.yy), f.x), f.y);
        }

        void main() {
            vec2 uv = gl_FragCoord.xy / resolution;
            vec2 iuv = vec2(1.0, 1.0) - uv;
            vec2 ratio = resolution / resolution.yx;
            vec2 ratio1610 = vec2(1.6, 0.625);
            vec2 dratio = clamp(ratio1610 - ratio, -1.0, 1.0);
            vec2 nratio = min(ratio, vec2(1.0, 1.0));
            vec2 pratio = nratio + 1.0;
            float ns = mix(-NOISE_GRANULARITY, NOISE_GRANULARITY,noise(gl_FragCoord.xy * vec2(2.01, 2.01))) * 8.0;

            vec3 bgCol_0 = vec3( 0.949, 0.933, 0.918);
            vec3 bgCol_1 = vec3( 0.898, 0.906, 0.871);
            vec3 bgCol_2 = vec3( 1.0, 1.0, 1.0);

            vec3 gradCol_green = vec3( 0.592, 0.588, 0.518);
            vec3 gradCol_red = vec3( 0.620, 0.71, 0.827);

            vec3 bgCol = mix(mix(bgCol_0, bgCol_1, smoothstep(0.25, 0.5, scroll)), bgCol_2, smoothstep(0.75, 1.0, scroll));
            vec3 tc = bgCol;

            float limry = clamp(dratio.y, -0.8, 0.0);
            float tprog = time;
            
            // ORIGINAL LAYOUT
            //bgCol = mix(bgCol, vec3(0.0,1.0,0.0), step(0.1, uv.x) * step(iuv.x + (0.1 + 0.9 * -limry * 1.05) + iuv.x * limry * 1.05, uv.y));
            //bgCol = mix(bgCol, vec3(1.0,0.0,0.0), step(0.4, uv.x) * step(iuv.x + (0.1 + 0.9 * -limry) + iuv.x * limry, uv.y));
            //bgCol = mix(bgCol, vec3(1.0,0.0,0.0), step(uv.x + 0.5 + 0.15 * -limry + uv.x * iuv.y, iuv.y));
            //bgCol = mix(bgCol, vec3(0.0,1.0,0.0), step(uv.x + 0.55 + 0.05 * clamp(ratio.y, 0.0, 3.0) - uv.x * -limry * 0.65, iuv.y));

            /*
            
            float green1 = iuv.x + (0.1 + 0.9 * -limry * 1.05) + iuv.x * limry * 1.05;
            float red1 = smoothstep(0.0, 0.5,scroll) + mouseX * 0.1;
            float red12 = iuv.x + (0.1 + 0.9 * -limry) + iuv.x * limry;
            
            bgCol = mix(bgCol, gradCol_green, smoothstep(green1, green1 + 0.5, uv.y - smoothstep(0.0, 0.95,scroll) + mouseY * 0.05) * 0.8 * 0.1);
            bgCol = mix(bgCol, gradCol_red, smoothstep(0.3 + red1, 0.9 + red1, uv.x) * smoothstep(red12 - 0.1, red12 + 0.4, uv.y - smoothstep(0.0, 1.0,scroll) + mouseY * 0.1) * 0.8 * 0.1);

            red1 = uv.x + 0.5 + 0.15 * -limry + uv.x * iuv.y;
            green1 = uv.x + 0.55 + 0.05 * clamp(ratio.y, 0.0, 3.0) - uv.x * -limry * 0.65;

            bgCol = mix(bgCol, gradCol_red, smoothstep(red1 - 0.2, red1 + 0.2, iuv.y - smoothstep(0.0, 1.0,1.0-scroll) + mouseY * 0.05) * 0.8 * 0.1);
            bgCol = mix(bgCol, gradCol_green, smoothstep(green1 - 0.15, green1 + 0.1, iuv.y - smoothstep(0.0, 0.95,1.0-scroll) + mouseY * 0.1) * 0.8 * 0.1); 
            
            */

            //bgCol = mix(bgCol, vec3(0.0,1.0,0.0), step(0.1, uv.x) * step(iuv.x + (0.1 + 0.9 * -limry * 1.05) + iuv.x * limry * 1.05, uv.y) * 0.1);
            //bgCol = mix(bgCol, vec3(1.0,0.0,0.0), step(0.4, uv.x) * step(iuv.x + (0.1 + 0.9 * -limry) + iuv.x * limry, uv.y) * 0.1);
            //bgCol = mix(bgCol, vec3(1.0,0.0,0.0), step(uv.x + 0.5 + 0.15 * -limry + uv.x * iuv.y, iuv.y) * 0.1);
            //bgCol = mix(bgCol, vec3(0.0,1.0,0.0), step(uv.x + 0.55 + 0.05 * clamp(ratio.y, 0.0, 3.0) - uv.x * -limry * 0.65, iuv.y) * 0.1);

            float green1 = iuv.x + (0.1 + 0.9 * -limry * 1.05) + iuv.x * limry * 1.05;
            float red1 = smoothstep(0.0, 0.5,scroll) + mouseX * 0.1;
            float red12 = iuv.x + (0.1 + 0.9 * -limry) + iuv.x * limry;
            // first Green stuff
            bgCol = mix(bgCol, gradCol_green, smoothstep(green1, green1 + 0.5, uv.y - smoothstep(0.0, 0.95,scroll) + mouseY * 0.05) * 0.8);
            bgCol = mix(bgCol, gradCol_green, smoothstep(0.5, 0.8, 1.0 - distance(vec2(uv.x * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) * 2.5), vec2(1.0 * ratio.x + cos((tprog+20.0)*0.3) * 0.1,0.55 + 0.8 * -limry + sin((tprog+20.0)*0.4) * 0.04))) * 0.8);
            bgCol = mix(bgCol, gradCol_green, smoothstep(0.6, 1.0, 1.0 - distance(vec2(uv.x * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) * 2.0), vec2(0.45 * ratio.x + cos((tprog+25.0)*0.3) * 0.04,0.85 + 0.4 * -limry + sin((tprog+25.0)*0.4) * 0.04))) * 0.8);
            bgCol = mix(bgCol, gradCol_green, smoothstep(0.8, 1.2, 1.0 - distance(vec2(uv.x * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) * 1.5), vec2(0.6 * ratio.x + cos((tprog+30.0)*0.3) * 0.08,0.58 + 0.4 * -limry + sin((tprog+30.0)*0.4) * 0.04))) * 0.8);
            bgCol = mix(bgCol, gradCol_green, smoothstep(0.8, 1.2, 1.0 - distance(vec2(uv.x * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll)), vec2(0.3 * ratio.x + cos((tprog + 35.0)*0.2) * 0.08,1.0 + 0.1 * -limry + sin((tprog + 35.0)*0.1) * 0.08))) * 0.8);


            // first Red stuff
            bgCol = mix(bgCol, gradCol_red, smoothstep(0.3 + red1, 0.9 + red1, uv.x) * smoothstep(red12 - 0.1, red12 + 0.4, uv.y - smoothstep(0.0, 1.0,scroll) + mouseY * 0.1 - 0.1 * 0.6));

            bgCol = mix(bgCol, gradCol_red, smoothstep(0.3, 0.8, 1.0 - distance(vec2((uv.x + mouseX * 0.05 - smoothstep(0.0, 0.95,scroll) * 1.5) * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) * 2.2 - mouseY * 0.05), vec2(0.7 * ratio.x + cos((tprog)*0.3) * 0.1,0.85 + 0.8 * -limry + sin((tprog)*0.4) * 0.04))) * 0.6 * smoothstep(0.3, 0.0, scroll));
            bgCol = mix(bgCol, gradCol_red, smoothstep(0.7, 1.0, 1.0 - distance(vec2((uv.x + mouseX * 0.04 - smoothstep(0.0, 0.95,scroll) * 1.8) * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) * 1.9 - mouseY * 0.04), vec2(0.47 * ratio.x + cos((tprog+110.01)*0.3) * 0.04,0.85 + 0.4 * -limry + sin((tprog+110.01)*0.4) * 0.04))) * 0.6);
            bgCol = mix(bgCol, gradCol_red, smoothstep(0.5, 1.1, 1.0 - distance(vec2((uv.x + mouseX * 0.1 - smoothstep(0.0, 0.95,scroll) * 2.5) * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) * 1.5 - mouseY * 0.1), vec2(0.6 * ratio.x + cos((tprog+5.0)*0.3) * 0.08,0.75 + 0.4 * -limry + sin((tprog+5.0)*0.4) * 0.04))) * 0.6);
            bgCol = mix(bgCol, gradCol_red, smoothstep(0.6, 1.2, 1.0 - distance(vec2((uv.x + mouseX * 0.06 - smoothstep(0.0, 0.95,scroll) * 2.5) * ratio.x, uv.y - smoothstep(0.0, 0.95,scroll) - mouseY * 0.06), vec2(0.3 * ratio.x + cos((tprog + 15.0)*0.2) * 0.08,1.0 + 0.13 * -limry + sin((tprog + 15.0)*0.1) * 0.08))) * 0.6);

            // second Red stuff
            red1 = uv.x + 0.5 + 0.15 * -limry + uv.x * iuv.y;
            green1 = uv.x + 0.55 + 0.05 * clamp(ratio.y, 0.0, 3.0) - uv.x * -limry * 0.65;

            bgCol = mix(bgCol, gradCol_red, smoothstep(red1 - 0.2, red1 + 0.4, iuv.y - smoothstep(0.0, 1.0,1.0-scroll) + mouseY * 0.05) * 0.8);
            bgCol = mix(bgCol, gradCol_green, smoothstep(green1 - 0.2, green1 + 0.4, iuv.y - smoothstep(0.0, 0.95,1.0-scroll) - (mouseY+0.5) * 0.2) * 0.8);

            // two circles layer
            red1 = smoothstep(0.1, 1.0, 1.0 - distance(vec2(((mouseX + 0.5)*0.5+0.25) * ratio.x, (-(mouseY - 0.5)*0.6+0.2)), vec2(uv.x * ratio.x, uv.y)));
            green1 = smoothstep(0.1, 1.0, 1.0 - distance(vec2((1.0-((mouseX + 0.5)*0.5+0.25)) * ratio.x, 1.0 - (-(mouseY - 0.5)*0.6+0.2)), vec2(uv.x * ratio.x, uv.y)));
            red12 = red1 * green1;


            tc = mix(tc, vec3(1.0), 0.7);
            //tc = mix(tc, gradCol_red, green1 * 0.25);
            //tc = mix(tc, gradCol_green, red1 * 0.35);
           // tc = mix(tc, min((gradCol_red + gradCol_green)*1.2, vec3(1.0)), red12 * 0.7);
            
            tc = mix(tc, gradCol_red, green1 * 0.35);
            tc = mix(tc, gradCol_green, red1 * 0.45);
            tc = mix(tc, min((gradCol_red + gradCol_green)*1.2, vec3(1.0)), red12 * 0.7);

            bgCol = mix(bgCol, tc, mix(toplayer, 0.9, smoothstep(0.0, 0.3, scroll) * smoothstep(0.9, 0.6, scroll)));




            float click = cprog * 0.5 + 0.5;

            bgCol = mix(bgCol, mix(gradCol_green, gradCol_red, clickX * clickY), smoothstep(0.01 * click + 0.001, 0.05 * click + 0.002, distance(vec2(clickX * ratio.x, clickY), vec2(uv.x * ratio.x, uv.y))) * smoothstep(0.1 * click + 0.004, 0.04 * click + 0.002, distance(vec2(clickX * ratio.x, clickY), vec2(uv.x * ratio.x, uv.y))) * (1.0 - distance(0.5, click)*2.0) * smoothstep(0.5, 0.6, click) * 0.2);

            bgCol += ns;

            gl_FragColor = vec4( bgCol, 1.0 );
        }
    `
};
const filter = {
    filterClass: '.filter-form',
    $filter : null,
    sliderClass: '.filter-slider',
    init: function(container = document, locoScroll){

        let obj = filter;
        obj.$filter = $(container).find(obj.filterClass);

        if(obj.$filter.length === 0){ return false;}

        $.each(obj.$filter, function() {
            let $this = $(this);
            let $inputs = $this.find('input[type="checkbox"]');
            let $houses = $this.find('.filter-svg');
            let $list = $(container).find('.filter-list');

            let $clear = $this.find('.btn-clear');

            let $sliders = $this.find(obj.sliderClass)
                .ionRangeSlider({
                    onFinish: function(data){
                        $this.submit();
                    }
            });

            $houses.on('click',function(e){
                $(this).toggleClass('is-active');
                let $input = $this.find('.filter-house-'+$(this).data('id'));

                if($input.prop('checked') === false){
                    $input.prop('checked',true);
                }else{
                    $input.prop('checked',false);
                }
                $this.submit();
            });

            $this.submit(function (e) {
                e.preventDefault();
                let $this = $(this);
                $.ajax({
                    data: $this.serialize(),
                    type: 'post',
                    url: $this.attr('action'),
                    beforeSend: function () {
                        //  gsap.to(window, {scrollTo: ($('.search-inner').offset().top - $('.header').height())});
                    },
                    success: function (data) {

                    },
                    complete: function (data) {

                    }
                }).done(function (data) {

                    if(data.length !== 0){
                        data = JSON.parse(data);
                        $list.html(data.html);
                        let and = '?';
                        if(data.query.length === 0){
                            and = ''
                        }
                        barba.history.add(window.location.origin+barba.url.parse(window.location.href).path+and+data.query, 'filter');
                        console.log(window.location.href);
                        history.pushState(null, '',window.location.href);
                    }
                    setTooltips();
                    locoScroll.update();
                    ScrollTrigger.refresh();
                });
            })

            let $reset = $this.find('.filter-inputs--reset');

            $reset.on('click', function(e){
                e.preventDefault();
                $this[0].reset();


                let $inputs = $this.find('input');
                $.each($inputs, function(){
                    $(this).prop('checked',false);
                });

                $.each($this.find(".filter-slider"), function(){
                    $(this).data("ionRangeSlider").reset();
                })

                $this.find('.filter-svg').removeClass('is-active');
                $this.submit();

                barba.history.add(window.location.origin+barba.url.parse(window.location.href).path, 'filter');

            })


            $inputs.on('change',function(){
                $this.submit();
            });


           // $this.submit();
        });


    }


}
const anims = {
    reveal: '.reveal',
    init : function(container = document){
    
        let $intro = $('.intro');
        let $intro_items = $intro.find('.reveal-intro')

        let tl = gsap.timeline({
            paused:true,
            delay: 0.5,
            force3D: true,
        });
        if($intro.length > 0){

            tl.fromTo($intro.find('.intro-logos'),
                {
                    autoAlpha:0
                },
                {
                    autoAlpha:1,
                }
            )
            tl.fromTo($intro.find('.deco-line'),
                {
                    autoAlpha:0,
                    width:0
                },
                {
                    autoAlpha:1,
                    width:'38px'
                },'-=0.2')
            tl.fromTo($intro.find('h1'),
                {
                    autoAlpha:0,
                    y:'20'
                },
                {
                    autoAlpha:1,
                    y:0
                },'-=0.4')
            tl.fromTo($intro.find('.bt-arrow'),
                {
                    scale:0
                },
                {
                    scale:1
                },'-=0.5'
            )

            tl.play()
        }

    },
    triggers: null,
    default: function(container = document){
        let $items = $(container).find('.reveal');
        let $para = $(container).find('.reveal-txt p');
        let $btns = $(container).find('.bt');
        let $points = $(container).find('.reveal-points');
        let $lines = $(container).find('.deco-lineAnimLeft');
        let $lines2 = $(container).find('.deco-lineAnimCenter');

        let $stagger = $(container).find('.reveal-stagger');

        $.each($stagger, function(){
            let $this = $(this);
            let $ico = $this.find('.reveal-staggerIco');
            let $deco = $this.find('.reveal-staggerDeco');
            let $p  = $this.find('.reveal-staggerP');

            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($ico,{
                autoAlpha: 0,
               // y:'20'
            },{
                autoAlpha:1,
                duration: 1
              //  y:'0'
            })

            tl.fromTo($deco,{
                width : 0
            },{
                width : '25%',
                duration: .5
            },'-=0.8')

            tl.fromTo($p,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0'
            },'-=0.75')

            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                // toggleClass: 'animate',

                animation: tl,
            });

        })

        $.each($lines,function(){

            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0',
            })


            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                // toggleClass: 'animate',

                animation: tl,
            });
        })
        $.each($lines2,function(){

            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($this,{
                width: 0,
                //autoAlpha: 0,
                y:'20'
            },{
                //autoAlpha:1,
                y:'0',
                width: '100%',
                duration: 15
            })


            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                // toggleClass: 'animate',
                animation: tl,
            });
        })

        $.each($para , function(){
            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0'
            })
            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                // toggleClass: 'animate',
                animation: tl,
            });
        });
        $.each($items , function(){
            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0'
            })
            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
               // toggleClass: 'animate',

                animation: tl,
            });
        });

        $.each($btns, function(){
            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($this,{
                autoAlpha: 0,
                scale:0
            },{
                autoAlpha:1,
                scale: 1
            })
            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                // toggleClass: 'animate',

                animation: tl,
            });
        })

        $.each($points, function(){
            let $this = $(this);
            let $ico = $this.find('.reveal-pointsIco');
            let $title = $this.find('.reveal-pointsTitle');
            let $txt = $this.find('.reveal-pointsTxt p');

            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            tl.fromTo($title,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0',
                onStart : function(){
                    $title.addClass('animate')
                },
            })

            $.each($txt, function(){
                tl.fromTo(this,{
                    autoAlpha: 0,
                    y:'20'
                },{
                    autoAlpha:1,
                    y:'0'
                },'-=0.25')
            })

            tl.fromTo($ico,{
                scale:0
            },{
                scale:1
            },'-=0.15')

            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                // toggleClass: 'animate',

                animation: tl,
            });

        })


        let $rooms = $(container).find('.list-rooms')

        $.each($rooms, function(){

            let $this = $(this);
            let $items = $this.find('a');

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $this,
                    scroller: '.wrapper',
                    start: "top-=100px 85%",
                    end: "bottom top",
                    scrub: true,
                }
            });

            tl.to($items[3], {
                yPercent: 75,
                ease: "none"
            }, 0)
            tl.to($items[0], {
                yPercent: 75,
                ease: "none"
            }, 0)

            tl.to($items[1], {
                yPercent: 50,
                ease: "none"
            }, 0)
            tl.to($items[2], {
                yPercent: 50,
                ease: "none"
            }, 0)

            /*tl.to($items[2], {
                yPercent: 15,
                ease: "none"
            }, 0)*/
        })

        let $deco = $(container).find('.para-deco');

        $.each($deco, function(){

            let $this = $(this);
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $this,
                    scroller: '.wrapper',
                    start: "top 85%",
                    end: "bottom top",
                    scrub: true,

                }
            });

            tl.fromTo($this.find('img'),
                {
                    yPercent: -15,
                    ease: "none"
                },{
                    yPercent: 15,
                    ease: "none"
                }, 0)

        })

        let $bird = $(container).find('.sct-front4--deco');
        $.each($bird, function(){
            let $this = $(this);
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $this,
                    scroller: '.wrapper',
                    start: "top 85%",
                    end: "bottom top",
                    scrub: true,

                }
            });

            tl.fromTo($this.find('img'),
                {
                    yPercent: 15,
                    ease: "none"
                },{
                    yPercent: -15,
                    ease: "none"
                }, 0)
        });


        let $list =$(container).find('.benefits-list2--item');

        $.each($list, function(index){

            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            index = '0.'+index;
            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0',
                delay:index
            })

            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                animation: tl,
            });
        })

        let $list2 = $(container).find('.sct-benefits5--item');

        $.each($list2, function(index){

            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            index = '0.'+index;
            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0',
                delay:index
            })

            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                animation: tl,
            });
        })


        let $list3 = $(container).find('.sct-benefits7--item');

        $.each($list3, function(index){

            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            index = '0.'+index;
            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0',
                delay:index
            })

            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                animation: tl,
            });
        })

        let $list4 = $(container).find('.projects-item');

        $.each($list4, function(index){

            let $this = $(this);
            let tl = gsap.timeline({
                paused:true,
                force3D: true,
            });

            index = '0.'+index;
            tl.fromTo($this,{
                autoAlpha: 0,
                y:'20'
            },{
                autoAlpha:1,
                y:'0',
                delay:index
            })

            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 85%",
                scroller: '.wrapper',
                animation: tl,
            });
        })

        let $paralax = $(container).find('.img-row');

        $.each($paralax, function(){
            let $this = $(this);
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $this,
                    scroller: '.wrapper',
                    start: "top 85%",
                    end: "bottom top",
                    scrub: true,

                }
            });

            let $items = $this.find('.img-row--item');

            tl.fromTo($items[0],
                {
                    yPercent: 12,
                    ease: "none"
                },{
                    yPercent: -15,
                    ease: "none"
                }, 0)

            tl.fromTo($items[1],
                {
                    yPercent: -12,
                    ease: "none"
                },{
                    yPercent: 15,
                    ease: "none"
                }, 0)

            tl.fromTo($items[2],
                {
                    yPercent: 12,
                    ease: "none"
                },{
                    yPercent: -15,
                    ease: "none"
                }, 0)

        })

    }
}
const news = {
  class : '.news',
  init: async function(container = document,locoScroll){
      let obj = this;
      let page = parseInt(container.dataset.page);
      const pages = parseInt(container.dataset.pages);
      const lang = container.dataset.lang;

      const news = container.querySelector('.news-container');
      const more = container.querySelector(".news-more");
      if(pages == '1') more.style.display = 'none';

      more.querySelector('button').addEventListener('click', (e) => {
        e.preventDefault();
        fetch(`${container.dataset.url}news/data/${page}?lang=${lang}`, {method: 'GET',headers: {}, }).then(res => res.json()).then(res => {
          const temp = document.createElement('div');
          temp.innerHTML = res.html;

          let $items = $(temp).find('.reveal');

          $.each($items , function(){
              let $this = $(this);
              let tl = gsap.timeline({
                  paused:true,
                  force3D: true,
              });

              tl.fromTo($this,{
                  autoAlpha: 0,
                  y:'20'
              },{
                  autoAlpha:1,
                  y:'0'
              })
              let trigger = ScrollTrigger.create({
                  trigger: this,
                  start: "top 85%",
                  scroller: '.wrapper',
                // toggleClass: 'animate',

                  animation: tl,
              });
          });

          while (temp.firstChild) {
            news.appendChild(temp.firstChild);
          }

     
          locoScroll.update();
        });
     
        page++;
        if(page == pages) more.style.display = 'none';
      })

  }
}
import Swiper from 'swiper/bundle';

const newSingle = {
  class : '.new',
  init: function(container = document,locoScroll){
      let obj = this;

      const swiper = new Swiper('.swiper', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
        breakpoints: {
          '780': {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          '1024': {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }
      });

  }
}
window.jQuery.ready(function(){
    console.log('init');
})

$(document).ready(function(){

    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    const wrapperClass = '.wrapper';
    const locoScroll = new LocomotiveScroll({
        el: document.querySelector(wrapperClass),
        smooth: true,
        lerp: 0.035,
        inertia: 0.5,
        passive: true,
    });
    // tell ScrollTrigger to use these proxy methods for the ".smooth-scroll" element since Locomotive Scroll is hijacking things

    ScrollTrigger.scrollerProxy(wrapperClass, {
        scrollTop(value) {
            return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
        }, // we don't have to define a scrollLeft because we're only scrolling vertically.
        getBoundingClientRect() {
            return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
        },
        // LocomotiveScroll handles things completely differently on mobile devices - it doesn't even transform the container at all! So to get the correct behavior and avoid jitters, we should pin things with position: fixed on mobile. We sense it by checking to see if there's a transform applied to the container (the LocomotiveScroll-controlled element).
        pinType: document.querySelector(wrapperClass).style.transform ? "transform" : "fixed"
    });

    locoScroll.on("scroll", ScrollTrigger.update);

    GradBg.init(locoScroll);

    const $header = $('.header');
    const $menu = $('.menu');

    scrollto.init(document,locoScroll);
    locoScroll.on('scroll',function(args){

        if(args.scroll.y > 50){
            menu.scrolled = true;
        }else{
            menu.scrolled = false;
        }

        if (args.scroll.y > 50 && !$menu.hasClass('active')) {
            $header.addClass('scrolled');

        } else {
            $header.removeClass('scrolled');
        }
    });

    menu.init(document,locoScroll);

    const $wrap = $('#gradbg, .wrap');

    // barba settings
    barba.init({
        timeout: 3000,
        prevent:({ el }) => !el.classList.contains('js-barba') || el.classList.contains('apart-sold'),
        cacheIgnore: true,
        transitions: [ {
            name: 'no-transition',
            from: {
                namespace: [
                    'floor',
                    'apartment',
                    'parking',
                    'houses'
                ]
            },
            to: {
                namespace: [
                    'houses',
                    'parking',
                    'floor',
                    'apartment'
                ]
            },
            leave(data) {


            },
            enter(data) {
                 GradBg.v.uniforms.toplayer = data.next.namespace == "home" ? 0.1 : 0.95;
            },
            once() {
                //console.log("ONCE");
            }
        },{
            name: 'default-transition',
            leave(data) {
                const done = this.async();
                gsap.to($wrap, {
                    opacity: 0,
                    duration: 0.2
                })
                setTimeout(()=>{done();},250);
            },
            enter(data) {
                const done = this.async();
                GradBg.v.uniforms.toplayer = data.next.namespace == "home" ? 0.1 : 0.95;
                gsap.fromTo($wrap, {
                    opacity: 0
                },{
                    delay:0.5,
                    opacity: 1
                });
                setTimeout(()=>{done();},250);
            },
            once() {
                //console.log("ONCE");
            }
        }],
        views: [
            {
                namespace: 'home',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    let $video = $(data.next.container).find('.sct-hero--video video');
                    if($video.length > 0){
                        $video[0].play();
                    }
                }
            },
            {
                namespace: 'gallery',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    gallery.init(data.next.container);
                }
            },
            {
                namespace: 'map',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    if (typeof google !== 'undefined') {
                        map.init(data.next.container, locoScroll);
                    }
                }
            },
            {
                namespace: 'duk',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    duk.init(data.next.container);
                }
            },
            {
                namespace: 'benefits',
                beforeEnter(data) {

                },
                afterEnter(data) {

                    if(typeof data.next.url.query.sect !== 'undefined'){
                        setTimeout(function(){
                            locoScroll.scrollTo($(data.next.container).find('.sct-benefits10')[0],{
                                offset: -75
                            })
                        },300);
                    }

                    let $video = $(data.next.container).find('video');
                    $.each($video, function(){
                        this.play();
                    })
                }
            },
            {
                namespace: 'houses',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    houses.init(data.next.container);
                    if(typeof data.next.url.query.floor !== 'undefined'){
                        $(data.next.container).find('.floor-nav-select[data-floor="'+data.next.url.query.floor+'"]').click();
                    }
                    filter.init(data.next.container, locoScroll);
                    setTooltips();

                    if(data.next.url.query['rooms%5B0%5D'] == '1' ||
                        data.next.url.query['rooms%5B0%5D'] == '1.5' ||
                        data.next.url.query['rooms%5B0%5D'] == '2' ||
                        data.next.url.query['rooms%5B0%5D'] == '3' ||
                        data.next.url.query['rooms%5B0%5D'] == '4'){

                        setTimeout(function(){
                            locoScroll.scrollTo($(data.next.container).find('.filter')[0],{
                                offset: -75
                            })
                        },300);
                    }

                }
            },
            {
                namespace: 'apartment',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    apartment.init(data.next.container);
                    setTooltips();
                    if(barba.history.previous !== null) {
                        let url = barba.history.previous.url.split('?');
                        let $btn = $(data.next.container).find('.bt-back');
                        if (typeof url[1] !== 'undefined') {

                            console.log(url);
                          //  $btn.attr('href', $btn.attr('href') + '&' + url[1]);
                        }
                    }



                }
            },
            {
                namespace: 'parking',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    parking.init(data.next.container);
                }
            },
            {
                namespace: 'favorites',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    setTooltips();
                }
            },
            {
                namespace: 'news',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    news.init(data.next.container,locoScroll);
                }
            },
            {
                namespace: 'new',
                beforeEnter(data) {

                },
                afterEnter(data) {
                    newSingle.init(data.next.container,locoScroll);
                }
            }
        ]
    });

    barba.hooks.beforeEnter((data) => {
        locoScroll.scrollTo(0,{duration :0,disableLerp : true});

        let $form = $(document).find('form.form');
        $form.removeClass('hide');
        $form.find('.error').removeClass('error');
        $form[0].reset();
        gsap.set($form.find('.form-inputs'),{autoAlpha:1,pointerEvents: 'auto'});
        gsap.set($form.find('.form-success'),{autoAlpha:0,pointerEvents: 'none'});
        

    });

    barba.hooks.before((data) => {

    });

    barba.hooks.enter((data) => {
        locoScroll.update();
        $trigger.removeClass('light');
        carousel(data.next.container);

    });

    carousel();

    function carousel(cont = document){
        if($(cont).find('.benefits-carousel').length){

            let slider = tns({
                container: $(cont).find('.benefits-carousel--inner')[0],
                items: 4,
                slideBy: 1,
             //   autoplay: true,
                loop: true,
                prevButton: $(cont).find('.benefits-carousel-prev button')[0],
                nextButton: $(cont).find('.benefits-carousel-next  button')[0],
                responsive: {
                    300: {
                        items: 1
                    },
                    800: {
                        items: 2
                    },
                    1024: {
                        items: 3
                    },
                    1280:{
                        items: 4
                    }
                },
                onInit: function (slider) {
                    let $items = $(slider.container).find('.tns-slide-active');
               //     $(cont).find.addClass('tns-slide--left');
              //      $($items[1]).addClass('tns-slide--right');
                }
            });


        }
    }

    let triggers = [];

    let $trigger= $('.popup1-toggle');


    function videoSize(){
        const $video = $(document).find('#frontpage-video');
        if($video.length > 0) {
            $video[0].pause();
            if ($(document).width() < 700) {
                $video.find('source').attr('src', $video.data('mobile'));
            }else{
                $video.find('source').attr('src', $video.data('pc'));
            }
            $video[0].load();
            $video[0].play();
        }
    }
    
    $(window).resize(function(){
        console.log('resize');
        videoSize();
    })
    

    barba.hooks.afterEnter((data) => {
        locoScroll.update();
        menu.changeHeader(data.next.container);
        setTimeout(function(){
            locoScroll.update();
            ScrollTrigger.refresh();
        },400);

        $.each(triggers, function(){
            this.kill();
        })
        triggers = [];

        let $sect = $(data.next.container).find('.toggle-pin');
        $.each($sect, function(){

            let $zone = $(this);
            let trigger = ScrollTrigger.create({
                trigger: this,
                start: "top 65%",
                end: "bottom 40%",
                scroller: wrapperClass,
                toggleClass: 'animate',
     //           markers: true,
                onEnter: function(){
                    $trigger.addClass($zone.data('type'));
                },
                onLeave: function(){
                    $trigger.removeClass($zone.data('type'));
                },
                onEnterBack: function(){
                    $trigger.addClass($zone.data('type'));
                },
                onLeaveBack: function(){
                    $trigger.removeClass($zone.data('type'));
                }
                //markers: true
            });
            triggers.push(trigger);
        })

        anims.default(data.next.container);
        form.init(data.next.container);
        videoSize();

    });

    let trigger = ScrollTrigger.create({
        trigger: $('.footer'),
        start: "top 65%",
        end: "bottom 40%",
        scroller: wrapperClass,
        toggleClass: 'animate',
    //    markers: true,
        onToggle: function(){
            $trigger.toggleClass('light');
        },
        //markers: true
    });

    barba.hooks.once((data)=> {
        //console.log(data.next.namespace);
        GradBg.v.uniforms.toplayer = data.next.namespace == "home" ? 0.1 : 0.95;
        menu.changeHeader(data.next.container);
    });

    $(document).on('click','.sold',function(e){
        e.preventDefault();
    });

    let $ico = $('.ico-favorites');
    $(document).on('click','.favorites-add', function(e){
        e.preventDefault(e);
        let $this = $(this);
        $this.toggleClass('active');

        if(ajax_url.length === 0 || typeof ajax_url === 'undefined'){
            return false;
        }

        $.ajax({
            url:ajax_url,
            data: {
                id: $this.data('id')
            },
            type: 'POST'
        }).done(function(data){
            data = JSON.parse(data);
            $ico.find('span').html(data.favs);
            if(data.favs === 0){
                $ico.removeClass('active')
            }else{
                $ico.addClass('active');
            }
        })
    }).on('mouseenter','.favorites-add', function(e){
        if($(this).hasClass('active')){
            this._tippy.setContent(favAlt);
        }else{
            this._tippy.setContent(fav);
        }
    })


    function intro(){
        let $intro = $('.intro');
        if($intro.length === 0){ return false;}

        locoScroll.on('scroll',function(args){
            if($intro.hasClass('active')) {
                if (args.scroll.y > 0) {
                    $intro.removeClass('active');
                    Cookies.set('intro_',1);
                    popup2();
                    popup3();
                }
            }
        })

        $(document).on('click',function(){
            if($intro.hasClass('active')) {
                $intro.removeClass('active');
                Cookies.set('intro_',1);
                popup2();
                popup3();
            }
        })
    }

    intro();

    $(document).on('click','.reset-filter', function(e){
        e.preventDefault();
        let $target = $(document).find($(this).data('target'));

        if($target.length > 0){
            $.each($target.find(".filter-slider"), function(){
                $(this).data("ionRangeSlider").reset();
            })
            $target.find('.filter-svg').removeClass('is-active');
            let $inputs = $target.find('input');

            $.each($inputs, function(){
                $(this).attr('checked', false)
            });

            $target[0].reset();
            $target.submit();
        }
    });




    function popup1(){
        let $trigger = $('.popup1-toggle');
        let $popup1 = $('.popup1');
        let $close = $('.popup1-close');
        let $cover = $('.popup1-cover');
        if($trigger.length > 0){
            $trigger.on('click', function(){
                let $this = $(this);
                if($this.hasClass('active')){
                    $this.removeClass('active')
                }else{
                    $this.addClass('active');
                }
                $popup1.toggleClass('active');
                $cover.toggleClass('active');
            });
            $close.on('click', function(){
                $trigger.removeClass('active');
                $popup1.removeClass('active');
                $cover.removeClass('active');
            })
            $cover.on('click',function(){
                $trigger.removeClass('active');
                $popup1.removeClass('active');
                $cover.removeClass('active');
            })
        }
    }

    popup1();

    function popup2(){

        let $trigger = $('.popup2-click');
        if(typeof popup_delay !== 'undefined'){
            setTimeout(function(){
                $trigger.click();
                Cookies.set('popup',1);
            },popup_delay)
        }
    }

    if(Cookies.get('intro_') === '1' && Cookies.get('popup') !== '1') {
        popup2();
    }

    function popup3(){

        let $trigger = $('.popup3-click');
        let timeout = null;
        if(typeof popup2_delay !== 'undefined'){
            timeout = setTimeout(function(){
                $trigger.click();
                Cookies.set('popup2',1);
            },popup2_delay)

            if(popup2_force === 1){
                $(document).mouseleave(function(e){
                    if(Cookies.get('popup2')!== '1') {
                        clearTimeout(timeout);
                        $trigger.click();
                        Cookies.set('popup2', 1);
                    }
                })
            }

        }

    }




    if(Cookies.get('intro_') === '1' && Cookies.get('popup2') !== '1') {
        popup3();
    }


    function gdpr(){

        let $gdpr = $('.gdpr');
        if(Cookies.get('gdpr') !== '1' && $gdpr.length > 0){

            gsap.fromTo($gdpr,{autoAlpha:0},{autoAlpha:1,delay:1.5,duration:1.5});

        }



        let $accept = $('.accept-gdpr');

        $accept.on('click', function(e){

            gsap.to($gdpr,{
                autoAlpha:0,
                onComplete: function(){
                    $gdpr.remove();
                    Cookies.set('gdpr',1,30);
                }})
        })
    }
    gdpr();

    anims.init();

    if(window.location.hash == '#contact') {
        locoScroll.scrollTo('.footer',{offset: -75})
    }

    let $mail = $('.mail-pin');

    if($mail.length > 0){
        setTimeout(function(){
            $mail.addClass("show");
        },450)
    }
})

function setTooltips(){
    if(typeof  window.tippy1  !== 'undefined'){
        window.tippy1.forEach(element => {
            element.destroy();
        })
        window.tippy1 = null;
    }
    if(typeof  window.tippy2 !== 'undefined'){
        window.tippy2.forEach(element => {
            element.destroy();
        })
        window.tippy2 = null;
    }

    window.tippy1 = tippy('.tippy1',{
        arrow: true,
        delay: [10, 0],
        offset: [0, 15],
        animation: 'shift-away',
    });

    window.tippy2 = tippy('.tippy2',{
        arrow: true,
        delay: [10, 0],
        offset: [0, 10],
        animation: 'shift-away',
    });


}

function setParams(name,value){
    if ('URLSearchParams' in window) {
      //  console.log(URLSearchParams);
        var searchParams = new URLSearchParams(window.location.search);
      //  console.log(searchParams);
        searchParams.set(name,value);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
    }
}
